import React from "react";
import {Svgs} from "@assets";
import styles from "./style.module.scss";
import {constant} from "@utils";
import moment from "moment";

export default function Component() {
  return (
    <>
      <div className={styles.container}>
        <Svgs.Logo fill="#ffffff" />
        <div>
          리브 온 라이프
          <br />
          대표 : 최재운 | 사업자등록번호 : 324-95-01895
          <br />
          대표번호 : 010-8378-4485
          <br />
          주소 : 경기도 광주시 행정타운로 68, 동하빌딩 2층 203호
        </div>
        <div>
          © {moment().format("YYYY")}. 리브온라이프. all rights reserved.
        </div>
      </div>
      <div className={styles.floating}>
        <div className={styles.floatingRow}>
          <div className={styles.pcContainer}>
            <div>
              리브온라이프로 장지상담서비스 진행 시,
              <br />
              <div>2차 장지 할인</div> <span>(5~10%)</span>
            </div>
            <div>* 상세 할인율은 상담 후 확정</div>
          </div>
          <div className={styles.division}>
            <div />
          </div>
          <div className={styles.textContainer}>
            <div className={styles.title}>
              19년 현장의 기준으로
              <br />
              <span>차분히 설명드리겠습니다</span>
            </div>
            <div className={styles.mobileDesc}>
              장지상담 서비스 진행 시 장지 할인 (5~10%)
            </div>
          </div>
          <div className={styles.division}>
            <div />
          </div>
          <div className={styles.btn} onClick={constant.CS_CLICK}>
            24시간 상담받기
          </div>
        </div>
      </div>
    </>
  );
}
